import { createApp } from 'vue'
import App from './App.vue'

import { router } from './router'
import store from './store'
import * as Sentry from '@sentry/vue'
import { setupScreenRecorder } from '@/services/screen-recorder'
import { setupUpdateCheckerRouter } from '@/lib/update-checker'

import 'bootstrap/scss/bootstrap.scss' 

const app = createApp(App)

if (import.meta.env.PROD) {
    Sentry.init({
        app,
        dsn: "https://78a8c5596ffcc4496abc54c796922b60@o4509571379953664.ingest.us.sentry.io/4509571381002240",
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["localhost", "https://lebes.auditaestoque.com.br", /\/api\//],
    })
}

setupUpdateCheckerRouter(router)

const start = async () => {
    
    
    try {
    // After mount: keep remote out of the sync entry critical path.
        await import('./router/load-remote-routes').then(({ loadRemoteRoutes }) => loadRemoteRoutes(router))
    } catch (error) {
        console.error('Error loading remote routes', error)
    }
    
    try {
        setupScreenRecorder(router)
    } catch (error) {
        console.error('Error setting up screen recorder', error)
    }

    app.use(router)
    app.use(store)
    app.mount('div.app')

}

start()
